module.exports = __webpack_public_path__ + "static/media/shadow-04.3d9e63b6.png";